import type { WhatsNewNote } from '../types/api';
import styles from './WhatsNewPill.module.css';

interface Props {
  /** Unread notes, newest first. The pill renders nothing when there are none. */
  unread: WhatsNewNote[];
  onOpen: () => void;
}

/**
 * The welcome screen's pointer to unread notes.
 *
 * Names the newest note when it is the only one, because a real title gets read and
 * a generic "see what's new" gets ignored. Several unread notes are counted instead.
 */
export default function WhatsNewPill({ unread, onOpen }: Props) {
  if (unread.length === 0) return null;
  const label = unread.length === 1 ? `New: ${unread[0].title}` : `${unread.length} new updates`;
  return (
    <button type="button" className={styles.pill} onClick={onOpen}>
      <span className={styles.dot} aria-hidden="true" />
      <span className={styles.label}>{label}</span>
    </button>
  );
}
